import React, { useState, useEffect } from 'react';
import './InstancesList.css';
import { useSelector } from 'react-redux';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// Custom TabPanel component for Material-UI
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function MultitoolSoftware() {
  const urls = useSelector((state) => state.url.urls);
  const [activeIndex, setActiveIndex] = useState(0);
  const [visibleStartIndex, setVisibleStartIndex] = useState(0);

  // 🔄 Adjust active index if URLs list changes and current index becomes invalid
  useEffect(() => {
    if (activeIndex >= urls.length) {
      setActiveIndex(Math.max(0, urls.length - 1));
    }
  }, [urls.length, activeIndex]);

  const handleChange = (event, newValue) => {
    setActiveIndex(newValue);
  };

  const handleLeftArrow = () => {
    if (visibleStartIndex > 0) {
      setVisibleStartIndex(prev => prev - 1);
    }
  };

  const handleRightArrow = () => {
    if (visibleStartIndex + 1 < urls.length - 1) {
      setVisibleStartIndex(prev => prev + 1);
    }
  };
  

  if (urls.length === 0) {
    return (
      <div className="mts-container">
        <div className="mts-empty-state" style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
          width: '100%'
        }}>
          <p style={{
            color: 'white',
            fontSize: '18px',
            textAlign: 'center',
            margin: 0
          }}>No Instances are created</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mts-container">
      <div className="mts-tabs-wrapper">
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center' }}>
            {/* Left Arrow */}
            <IconButton
              className="mts-scroll-arrow mts-scroll-arrow-left"
              onClick={handleLeftArrow}
              sx={{
                display: { xs: 'inline-flex', sm: 'none' },
                color: '#fff',
                ml: 1,
                mr: 1,
                minWidth: '40px',
                height: '40px',
                '&:disabled': {
                  color: 'rgba(255, 255, 255, 0.3)',
                }
              }}
              disabled={visibleStartIndex === 0}
            >
              <ChevronLeftIcon />
            </IconButton>
            <Tabs
              value={activeIndex}
              onChange={handleChange}
              aria-label="instance tabs"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                flex: 1,
                minWidth: 0,
                '& .MuiTab-root': {
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '1rem',
                  textTransform: 'none',
                  minWidth: 120,
                  maxWidth: 160,
                  padding: '12px 16px',
                  margin: '0 4px',
                  '&.Mui-selected': {
                    color: '#fff',
                    backgroundColor: '#111216',
                    borderRadius: '12px 12px 0 0',
                    boxShadow: '0 4px 16px rgba(0,255,133,0.10)',
                  },
                  '&:hover': {
                    backgroundColor: '#2c313a',
                    borderRadius: '12px 12px 0 0',
                  }
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#00ff85',
                  height: 3,
                },
                '& .MuiTabs-scrollButtons': {
                  display: 'none',
                }
              }}
            >
              {urls.map((tab, idx) => (
                <Tab
                  key={tab.envId || idx}
                  label={tab.name || `Tab ${idx + 1}`}
                  {...a11yProps(idx)}
                  sx={{
                    display: {
                      xs: (idx >= visibleStartIndex && idx < visibleStartIndex + 2) ? 'flex' : 'none',
                      sm: 'flex'
                    }
                  }}
                />
              ))}
            </Tabs>
            <IconButton
              className="mts-scroll-arrow mts-scroll-arrow-right"
              onClick={handleRightArrow}
              sx={{
                display: { xs: 'inline-flex', sm: 'none' },
                color: '#fff',
                ml: 1,
                mr: 1,
                minWidth: '40px',
                height: '40px',
                '&:disabled': {
                  color: 'rgba(255, 255, 255, 0.3)',
                }
              }}
              disabled={visibleStartIndex >= urls.length - 2}
            >
              <ChevronRightIcon />
            </IconButton>
          </Box>

        </Box>
      </div>
      <main className="mts-content-container">
        {urls.map((url, index) => (
          <CustomTabPanel key={index} value={activeIndex} index={index}>
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ height: '80vh' }}>
                <iframe
                  src={url.url}
                  height="100%"
                  style={{ border: '1px solid #ccc', borderRadius: 8, width: '80vw' }}
                  title={`iframe-${index}`}
                />
              </div>
            </div>
          </CustomTabPanel>
        ))}
      </main>
    </div>
  );
}
